export function pointsLocator() {
  const jsonData = require("./data115.json");
  // console.log(jsonData);

//   var numKey = {};
  // ['Food', 'Women Clothing', "Men Clothing", "Kids Clothing", "Toys", "Sanitory"]
//   var allSet = new Set();
  var foodSet = [];
  var womenSet = [];
  var menSet = [];
  var kidsSet = [];
  var toysSet = [];
  var saniSet = [];
  jsonData.forEach((each) => {
    if (each) {
    //   numKey[each.StoreNumber] = each;
    //   allSet.add(each.StoreNumber);
      if (each.tags.includes("Food")) foodSet.push(each);
      if (each.tags.includes("Women Clothing")) womenSet.push(each);
      if (each.tags.includes("Men Clothing")) menSet.push(each);
      if (each.tags.includes("Kids Clothing")) kidsSet.push(each);
      if (each.tags.includes("Toys")) toysSet.push(each);
      if (each.tags.includes("Sanitory")) saniSet.push(each);
    }
  });

  return [
    jsonData,
    foodSet,
    womenSet,
    menSet,
    kidsSet,
    toysSet,
    saniSet,
  ];
}
